import { ICanvasScaler } from "../../../../../../canvas/ICanvasScaler";
import { BasePageView } from "../../../../common/components/BasePageView";
import { RaidResourcePackage } from "../../resources/RaidResourcePackage";
import { PromiseCompletionSource } from "../../../../../../shared/async/PromiseCompletionSource";
import { FadeScreen } from "../../../../game/components/FadeScreen";
import { SoundsResourcePackageWrapper } from "../../../../common/resources/SoundsResourcePackageWrapper";
import { ShieldExplosiveShaderAnimation } from "../../components/shield/ShieldExplosiveShaderAnimation";
import { IDestroyOptions } from "pixi.js";

export class ShieldPage extends BasePageView {
    private readonly raidResources: RaidResourcePackage;
    private readonly soundResources: SoundsResourcePackageWrapper;
    private fadeScreen: FadeScreen;
    private shieldExplosiveAnimation: ShieldExplosiveShaderAnimation;
    private viewCompletionSource: PromiseCompletionSource<void>;

    public constructor(
        canvasScaler: ICanvasScaler,
        raidResources: RaidResourcePackage,
        soundResources: SoundsResourcePackageWrapper,
        viewCompletionSource: PromiseCompletionSource<void>) {
        super(canvasScaler);
        this.raidResources = raidResources;
        this.soundResources = soundResources;
        this.viewCompletionSource = viewCompletionSource;
        this.build();
        this.once("added", this.showComponents.bind(this));
        this.eventMode = "static";
        this.on("pointerup", this.skipAnimations, this);
    }

    protected override build(): void {
        const width = this.canvasScaler.referenceWidth;
        const height = this.canvasScaler.referenceHeight;
        this.fadeScreen = new FadeScreen(0.3, 0, 0.9, width, height);
        this.fadeScreen.eventMode = "static";
        this.addChild(this.fadeScreen);
        this.shieldExplosiveAnimation = new ShieldExplosiveShaderAnimation(this.canvasScaler, this.raidResources, this.soundResources);
        this.addChild(this.shieldExplosiveAnimation);
        super.build();
    }

    private async showComponents(): Promise<void> {
        this.fadeScreen.fadeIn();
        await this.shieldExplosiveAnimation.play();
        this.shieldExplosiveAnimation.destroy();
        await this.hidePage();
    }

    private async hidePage(): Promise<void> {
        await this.fadeScreen.fadeOut();
        this.viewCompletionSource.complete();
    }

    private skipAnimations(): void {
        if (this.shieldExplosiveAnimation != null && this.shieldExplosiveAnimation.isActive) {
            this.shieldExplosiveAnimation.setProgress(1);
        }
    }

    protected override layout(width: number, height: number): void {
        this.fadeScreen.width = width;
        this.fadeScreen.height = height;
        this.shieldExplosiveAnimation.position.set(width * 0.5, height * 0.5);
        super.layout(width, height);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.off("pointerup", this.skipAnimations, this);
        super.destroy(options);
    }
}
